import React, { useContext, useState } from "react";
import "./NewHeader.css";
import { userContext } from "src/context/UserContext";

const NewHeader = () => {
  const { user } = useContext(userContext);

  const messages = [
    "Unlock Your Business Potential: Exclusive Logistics Exam Reveals Cost-Saving Strategies and Growth Opportunities!",
    "Attention Entrepreneurs: Elevate Your Logistics Game with Insider Tips from our Exclusive Exam - Limited Slots Available!",
    "Small Business Alert: Maximize Efficiency and Minimize Costs with Our Logistics Exam - Act Now for Special Discounts!",
  ];

  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(true);

  const handleNext = () => {
    setCurrent((prev) => (prev + 1) % messages.length);
  };

  const handlePrev = () => {
    setCurrent((prev) => (prev - 1 + messages.length) % messages.length);
  };

  return (
    <section>
      <div id="whatsapp-button">
        <a href="https://wa.me/254794397129" target="_blank" class="float">
          <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/WhatsApp_icon.png" alt="WhatsApp" style={{width : 60,height : 60}} />
        </a>
      </div>
      <div
        className={`header-arrow-content-toggle-section ${!visible ? "d-none" : ""
          }`}
      >
        <div className="top-banner container-xxl">
          <button className="arrow" onClick={handlePrev}>
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <button className="arrow" onClick={handleNext}>
            <i className="fa-solid fa-arrow-right"></i>
          </button>
          <span className="message pe-md-3 d-none d-md-block">
            {messages[current]}
          </span>
          <button className="close" onClick={() => setVisible(false)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="top-banner pt-0 d-block d-md-none ps-2">
          <span className="message">{messages[current]}</span>
        </div>
      </div>

      <div className="header-contact-section">
        <div className="container-xxl top-banner-contact">
          <div className="email-phone-div d-md-flex gap-5">
            <div className="email-div mb-2 mb-md-0">
              <a href="tel:+254794397129" className="d-flex gap-2">
                <span>
                  <i class="fa-solid fa-phone yellow"></i>{" "}
                </span>
                <span>
                  +254794397129
                </span>
              </a>
            </div>
            <div className="email-div">
              <a href="mailto:info@bebamzigo.com" className="d-flex gap-2">
                <span>
                  <i class="fa-regular fa-envelope yellow"></i>{" "}
                </span>
                <span>info@bebamzigo.com</span>
              </a>
            </div>
          </div>
          <div className="social-links-div d-flex gap-3">
            <a href="https://www.facebook.com/profile.php?id=61559655251381">
              <i class="fa-brands fa-facebook-f"></i>
            </a>
            <a href="https://x.com/Bebamzigoltd">
              <i class="fa-brands fa-x"></i>
            </a>
            <a href="https://www.youtube.com/@bebamzigoafrica3642">
              <i class="fa-brands fa-youtube"></i>
            </a>
            <a href="https://www.instagram.com/bebamzigo_official/">
              <i class="fa-brands fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@bebamzigo.ke0?_r=1&_t=ZS-94cYRHqXghd">
              <i class="fa-brands fa-tiktok"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="header-logo-navs-section bg-white">
        <div className="container-xxl top-banner-contact">
          <nav class="navbar navbar-expand-lg navbar-light w-100 p-0">
            <div class="container-fluid p-0">
              <a class="navbar-brand me-xl-3 me-md-3 custom-logo-header" href="/">
                <img
                  className="img-fluid w-75"
                  src="/assets/images/logo.png"
                  alt=""
                />
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse mt-lg-0 mt-3" id="navbarNav">
                <ul class="navbar-nav w-100 align-items-center">
                  <li className="nav-item px-xl-2 px-1">
                    <a className="nav-link" href="/">
                      HOME
                    </a>
                  </li>
                  <li className="nav-item  px-xl-2 px-1">
                    <a className="nav-link" href="/login">
                      SHIPPER
                    </a>
                  </li>
                  <li className="nav-item  px-xl-2 px-1">
                    <a className="nav-link" href="/login">
                      TRANSPORTER
                    </a>
                  </li>
                  <li className="nav-item  px-xl-2 px-1">
                    <a className="nav-link" href="/login">
                      DRIVER
                    </a>
                  </li>
                  <li className="nav-item  px-xl-2 px-1">
                    <a className="nav-link" href="/login">
                      TRACK ITEM
                    </a>
                  </li>
                  <li className="nav-item px-xl-2 px-1">
                    <a className="nav-link" href="/blog">
                      BLOGS
                    </a>
                  </li>
                  <li className="nav-item px-xl-2 px-1">
                    <a className="nav-link" href="/careers">
                      CAREERS
                    </a>
                  </li>
                  <li className="nav-item px-xl-2 px-1">
                    <a className="nav-link" href="/#contact-us">
                      CONTACT US
                    </a>
                  </li>
                  <div className="d-flex align-items-center my-3 my-lg-0 ms-lg-auto">
                    <li
                      className="nav-item my-lg-0 my-2"
                      id="SignupBtMenu"
                    >
                      <a className="nav-link p-0" href="#">
                        <button className="btn signup-btn">Download App</button>
                      </a>
                    </li>
                    {!user?.token && (
                      <li
                        className="nav-item my-lg-0 my-2 ms-sm-3 ms-xl-3 ms-lg-2 ms-2"
                        id="SignupBtMenu"
                      >
                        <a className="nav-link p-0" href="/signup">
                          <button className="btn rounded-pill">Sign Up</button>
                        </a>
                      </li>
                    )}
                    <li
                      className="nav-item ms-sm-3 ms-2 my-lg-0 my-2 ms-xl-3 ms-lg-2"
                      id="loginBtMenu"
                    >
                      {user?.token ? (
                        <a className="nav-link p-0" href="/dashboard">
                          <button className="btn rounded-pill">My Account</button>
                        </a>
                      ) : (
                        <a className="nav-link p-0" href="/login">
                          <button className="btn rounded-pill">Log In</button>
                        </a>
                      )}
                    </li>
                  </div>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </section>
  );
};

export default NewHeader;
